<template>
    <div
        class="message-card"
        :class="[ direction, { 'no-reply': !message } ]"
    >
        <div class="wrapper">
            <AppImage
                class="avatar"
                title="avatar"
                :src="avatar"
                :fallback="require('@/assets/img/default-avatar.png')"
            />

            <div>
                <span class="name">
                    {{ sender }}
                </span>

                <span class="date">
                    {{ dateTime }}
                </span>
            </div>
        </div>

        <div class="wrapper" v-if="message">
            <p class="message" v-html="message"> </p>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		avatar: {
			type: String,
			default: ''
		},

		sender: {
			type: String,
			default: ''
		},

		dateTime: {
			type: String,
			default: ''
		},

		message: {
			type: String,
			default: ''
		},

		direction: {
			type: String,
			default: 'lrt'
		}
	}
}
</script>

<style lang="scss" scoped>
    .message-card {
        border-top: 1px solid lighten($default-light, 12%);
        padding-top: 1em;

		&.no-reply {
			border-bottom: none;
		}

        .avatar {
            flex-shrink: 0;
            height: 2.5em;
            width: 2.5em;
            border-radius: 50%;
            margin: 0 5px;
            background-size: cover;
        }

        .name, .date {
            margin-right: 5px;
            display: block;
            align-self: center;
        }

        .date {
            font-size: .8em;
            color: $default-light;
        }

        .wrapper {
           display: flex;
           align-items: center;

            .message {
                width: 100%;
                word-break: break-all;
                direction: ltr;
                margin-top: 20px;
            }
        }

        &.rtl {
            direction: rtl;
        }

        &.ltr {
            direction: ltr;
        }
    }
</style>
